// extracted by mini-css-extract-plugin
export default {"main":"e8ee555c60 c9900fcd17 _32faf4450f _01a1e2288b","title":"_6c5173300d"};